// PlaygroundMap.js
import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
});

function PlaygroundMap() {
  const [userLocation, setUserLocation] = useState(null);
  const [playgrounds, setPlaygrounds] = useState([]);
  const [locationDenied, setLocationDenied] = useState(false);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const { latitude, longitude } = pos.coords;
        setUserLocation([latitude, longitude]);

        // Overpass API query including nodes, ways, and relations
        const query = `
        [out:json][timeout:25];
        (
          node["leisure"~"playground|pitch|sports_centre|stadium|fitness_centre|sports_hall"](around:5000,${latitude},${longitude});
          node["sport"](around:5000,${latitude},${longitude});
          way["leisure"~"playground|pitch|sports_centre|stadium|fitness_centre|sports_hall"](around:5000,${latitude},${longitude});
          way["sport"](around:5000,${latitude},${longitude});
          relation["leisure"~"playground|pitch|sports_centre|stadium|fitness_centre|sports_hall"](around:5000,${latitude},${longitude});
          relation["sport"](around:5000,${latitude},${longitude});
        );
        out center tags;
      `;

        try {
          const url =
            "https://overpass-api.de/api/interpreter?data=" +
            encodeURIComponent(query);
          const res = await fetch(url);
          const data = await res.json();

          const places = data.elements.map((el) => ({
            id: el.id,
            name: el.tags?.name || "Unnamed Facility",
            type: el.tags?.leisure || "sports facility",
            lat: el.lat || el.center?.lat,
            lon: el.lon || el.center?.lon,
          }));

          setPlaygrounds(places);
        } catch (err) {
          console.error("Error fetching sports facilities:", err);
        }
      },
      (err) => {
        console.warn("User denied location:", err);
        setLocationDenied(true);
      }
    );
  }, []);

  if (locationDenied) {
    return (
      <div className="text-center text-red-600 font-medium mt-4">
        🚫 Location access denied. Cannot show nearby sports facilities.
      </div>
    );
  }

  if (!userLocation) {
    return (
      <div className="text-center text-gray-500 font-medium mt-4">
        ⏳ Detecting your location...
      </div>
    );
  }

  return (
    <MapContainer center={userLocation} zoom={14} className="h-full w-full rounded-lg">
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/">OSM</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />

      {/* User Marker */}
      <Marker position={userLocation}>
        <Popup>📍 You are here</Popup>
      </Marker>

      {/* Sports Facilities */}
      {playgrounds.map((pg) => (
        <Marker key={pg.id} position={[pg.lat, pg.lon]}>
          <Popup>
            <strong>{pg.name}</strong> <br />
            {pg.type}
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}

export default PlaygroundMap;